/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */

import {useTranslation} from "react-i18next";
import React from "react";
import {
    DATE_TIME_FORMAT_NAME_MODEL,
    downloadActionFile,
    getDateFormat
} from "../../../../../Apis/functions";
import {IconCube3d, IconMaterialType, PersonChip} from "../../../../../components/buttons/IconButtons";
import CustomFileCard from "../../../../../components/CustomFileCard";
import CustomChip from "../../../../../components/CustomChip";
import {colors} from "../../../../../enums/colors";
import {STATUS_MODEL} from "../../../../../enums/statusEnum";
import {FILE_MODEL} from "../../../Visitor/Visitor/Model/Model";
import {getUnitTransByName} from "../../../Dining/Ingredients/Model/Models";

const MaterialRequestDetailsListSection = ({ contentTableRef, data }) => {
    const { t } = useTranslation();

    return (
        <>
            <div className={"background-general-00 border-radius-8px border-full-shades-400"}>
                <div className={"col-12 p-3 background-shades-100 border-radius-top-8px border-bottom-shades-400 h-72px d-flex align-items-center"}>
                    <p className={"fs-16px ibl-font-w-600"}> {t("materials")}</p>
                </div>
                <div ref={contentTableRef} className={"overflow-y-auto"}>
                    <div className={"row mt-3"}>
                        { data?.items?.map(e => {
                            const fileData = e?.itemEvidence ? e.itemEvidence : null;
                            const file = e?.itemEvidence ? FILE_MODEL.set(e.itemEvidence) : null;
                            return <>
                                <div className={"col-12 mb-3"}>
                                    <div className={"row border-radius-8px background-shades-50 border-full-shades-300 "}>
                                        <div className={"col-12 p-3"}>
                                            <div className={"d-flex justify-content-between"}>
                                                <div className={"d-flex align-items-center"}>
                                                    <div className={"background-primary-25 border-radius-8px mr-2 p-2"}>
                                                        <IconCube3d width={30} height={30}/>
                                                    </div>
                                                    <span className={"ibl-font-w-600 fs-14px"}> {e.name}</span>
                                                </div>
                                                <div>
                                                    <div className={"fs-12px d-flex justify-content-end"}>
                                                        {t("quantity")}
                                                    </div>
                                                    <CustomChip
                                                        background={colors.secondary100}
                                                        fontColor={colors.secondary700}
                                                        borderColor={colors.secondary150}
                                                        legend={`${e.quantity} ${t(getUnitTransByName(e.measurementUnitName))}`}
                                                        icon={<IconMaterialType width={14} height={14} />}
                                                        className='icon-color-secondary-700'
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        { [STATUS_MODEL.DISPATCHED, STATUS_MODEL.DISCREPANCY].includes(data?.dispatchStatusId)
                                        && fileData && <>
                                            <div className={"col-12"}>
                                                <div className='border-bottom-shades-300 mb-3' />
                                            </div>

                                            <div className={"col-12 mb-3"}>
                                                <div className={"row background-shades-100 border-full-shades-300 border-radius-8px p-3"}>
                                                    <div className={"d-flex p-0"}>
                                                        <div className={"mr-3"}>
                                                            <PersonChip className={"icon-color-shades-400"}/>
                                                        </div>
                                                        <div className={"w-100"}>
                                                            <div>
                                                                <div className={"ibl-font-w-600 fs-14px"}>{fileData?.uploadedBy}</div>
                                                                <div className={"mt-1 mb-3 fs-14px"}>
                                                                    {getDateFormat(new Date(), null, DATE_TIME_FORMAT_NAME_MODEL.shortMonth)}
                                                                </div>
                                                            </div>

                                                            <div className={"background-general-00 border-full-shades-300 border-radius-8px p-2 w-100 mb-3"}>
                                                                {fileData?.note}
                                                            </div>

                                                            <div>
                                                                {file && <CustomFileCard
                                                                    classes={"border-0"}
                                                                    classContent={"background-shades-50 border-radius-8px border-full-shades-300"}
                                                                    Icon={file?.Icon}
                                                                    title={file?.name}
                                                                    fileValue={file?.filePath}
                                                                    subtitle={`${file.size} ${t('uploaded')}: ${getDateFormat(fileData?.createdAt)}`}
                                                                    showChip={false}
                                                                    buttonId={"btn_mrc_download_" + e.id}
                                                                    onClick={() => downloadActionFile(file?.filePath)}
                                                                />
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                        }
                                    </div>
                                </div>
                            </>
                        })}
                    </div>
                </div>
            </div>
        </>
    );
};

export default MaterialRequestDetailsListSection;
